import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Box, Typography, List, Button, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { usePopupState, bindToggle } from "material-ui-popup-state/hooks";
import Checkbox from '../checkbox';
import ListItemPopover from '../list-item-popover';
import { useTranslate } from 'react-admin';
import { convertPriorityText } from '../utils';

// Icons
import icBlueAdd from '../assets/icons/icBlueAdd.png';
import { DeleteOutline, EditOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.text.secondary,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        marginTop: theme.spacing(1),
        paddingLeft: 0,
    },
    childItem: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    subjectText: {
        fontFamily: 'UniviaPro',
        fontSize: 14,
        fontWeight: '500',
        color: '#237fc2'
    },
    anotherText: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontFamily: 'UniviaPro',
        fontSize: 11,
        fontWeight: '500',
        color: '#88898c',
        maxWidth: "250px",
    },
    message: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "350px",
        fontFamily: 'UniviaPro',
        fontSize: 11,
        fontWeight: '500',
        color: '#88898c'
    },
    iconContainer: {
        minWidth: 'unset',
        backgroundColor: '#e5f1f8',
        position: 'absolute',
        top: 32,
        right: 16,
        padding:'5px 5px'
    },
    icon: {
        width: 16,
        height: 16
    },
    iconPopover: {
        minWidth: 30
    }
}));

function TableTemplateItem({ item, onCheck, onDelete, onEdit, isDelete, isUpdate }) {
    const classes = useStyles();
    const translate = useTranslate();
    const popupState = usePopupState({ variant: 'popper', popupId: 'delete-table-item' });

    const onDeleteItemClick = () => {
        popupState.close();
        onDelete(item.id);
    }

    const onEditItemClick = () => {
        popupState.close();
        onEdit();
    }

    return (
        <List style={{ paddingTop: 10, paddingBottom: 0 }}>
            <ListItem className={classes.root} button>
                <Box flex={0.5} className={classes.childItem} px={1}>
                    {
                        isDelete &&
                        <Checkbox onClick={() => onCheck(item.id)} checked={item.checked} />
                    }
                </Box>
                <Box flex={2} className={classes.childItem}>
                    <Typography className={classes.subjectText}>{item.name}</Typography>
                </Box>
                <Box flex={3} className={classes.childItem}>
                    <Typography className={classes.anotherText}>{item.subject}</Typography>
                </Box>
                <Box flex={4} className={classes.childItem}>
                    <Typography className={classes.message}>{item.message}</Typography>
                </Box>
                <Box flex={1} className={classes.childItem}>
                    <Typography className={classes.anotherText}>{convertPriorityText(item.priorityType)}</Typography>
                </Box>
                <Box flex={1} className={classes.childItem}>
                    <Typography className={classes.anotherText}>{item.dyslexie ? (translate(`pos.messages.yes`)) : (translate(`pos.messages.no`))}</Typography>
                </Box>
                <Box flex={0.5}></Box>
            </ListItem>
            {
                isUpdate &&
                <Button className={classes.iconContainer} {...bindToggle(popupState)}>
                    <img alt='' src={icBlueAdd} className={classes.icon} />
                </Button>
            }
            <ListItemPopover popupState={popupState}>
                <List component="nav" aria-label="main mailbox folders">
                    <ListItem button onClick={onEditItemClick}>
                        <ListItemIcon className={classes.iconPopover}>
                            <EditOutlined />
                        </ListItemIcon>
                        <ListItemText primary={translate('pos.common.edit')} />
                    </ListItem>
                    <ListItem button onClick={onDeleteItemClick}>
                        <ListItemIcon className={classes.iconPopover}>
                            <DeleteOutline />
                        </ListItemIcon>
                        <ListItemText primary={translate('pos.common.delete')} />
                    </ListItem>
                </List>
            </ListItemPopover>
        </List>
    );
}

TableTemplateItem.propTypes = {
    item: PropTypes.object.isRequired,
    onCheck: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default TableTemplateItem;
